/**
 * SECTION - DEPARTMENTS
 */

import LocalSelector from "../containers/LocalSelector";
import { views } from "./../services/constants";

const { education } = views;

const DepartmentRoutes = {
  routes: [
    {
      path: ["/departments-schools", "/departamentos-escolas"],
      component: LocalSelector,
      props: {
        activeView: education,
        document: "departmentList"
      }
    }
    /*{
      path: ["/d", "/d"],
      component: LocalSelector,
      props: {
        activeView: education,
        document: "departmentList"
      }
    },
    {
      path: ["/d/:id", "/d/:id"],
      component: LocalSelector,
      props: {
        activeView: education,
        document: "department"
      }
    },
    {
      path: ["/d/:id/a", "/d/:id/a"],
      component: LocalSelector,
      props: {
        activeView: education,
        document: "departmentAbout"
      }
    }*/
  ]
};

export default DepartmentRoutes;
